import { APP_URL } from '../config';

const included = [
  'Live telemetry & charts',
  'Trips, map & charging history',
  'Battery, pack & powertrain diagnostics',
  'Alerts & remote commands',
  'All your vehicles',
  'Passkey + MFA security',
];

export default function Pricing(): JSX.Element {
  return (
    <section id="pricing" className="container-page py-20 md:py-28">
      <div className="mx-auto max-w-2xl text-center">
        <p className="eyebrow">Pricing</p>
        <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
          Free while we’re getting started
        </h2>
        <p className="mt-4 text-lg text-muted">
          No credit card and no trial countdown. Running a car on Garage costs
          real money in AWS bills, so this won’t be free forever — but it is
          now, and you’ll hear about it well before that changes.
        </p>
      </div>

      <div className="mx-auto mt-12 max-w-md">
        <div className="card text-center">
          <div className="eyebrow">Garage</div>
          <div className="mt-3 flex items-end justify-center gap-1">
            <span className="text-5xl font-bold tracking-tight">$0</span>
            <span className="mb-1.5 text-muted">/ month, for now</span>
          </div>
          <p className="mt-2 text-sm text-muted">Everything included.</p>
          <ul className="mt-6 space-y-2.5 text-left text-sm">
            {included.map((item) => (
              <li key={item} className="flex items-center gap-2.5">
                <span className="text-accent">✓</span>
                {item}
              </li>
            ))}
          </ul>
          <a
            className="btn btn-primary btn-lg mt-7 w-full"
            href={`${APP_URL}/?request=1`}
          >
            Request early access
          </a>
        </div>
      </div>
    </section>
  );
}
